import { render, staticRenderFns } from "./BbsEmoji.vue?vue&type=template&id=6a3a7084&"
import script from "./BbsEmoji.vue?vue&type=script&lang=js&"
export * from "./BbsEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/BbsEmoji.vue"
export default component.exports